
import Timer from "../fable-library-js.5.13.0/Timer.js";
import { add } from "../fable-library-js.5.13.0/Observable.js";
import { startImmediate } from "../fable-library-js.5.13.0/Async.js";

export function Log_onError(text, ex) {
    console.error(text, ex);
}

export function Log_toConsole(text, o) {
    console.log(text, o);
}

export function Timer_delay(interval, callback) {
    let t;
    let returnVal = new Timer(interval);
    returnVal.AutoReset = false;
    t = returnVal;
    add(callback, t.Elapsed());
    t.Enabled = true;
    t.Start();
}

export function AsyncHelpers_start(x) {
    Timer_delay(1, (_arg) => {
        startImmediate(x);
    });
}

